import "core-js";
import { enableES5 } from "immer";
import React from "react";
import ReactDOM from "react-dom";
import AppWrapper from "src/AppWrapper";
import App from "src/containers/App";
import "src/iconFont";

enableES5();
(function () {
  ReactDOM.render(
    <React.StrictMode>
      <AppWrapper>
        <App />
      </AppWrapper>
    </React.StrictMode>,
    document.getElementById("root")
  );
})();
